let dataLayersWP = {
  el: {
    referrer: !!document.referrer !== false ? document.referrer : 'NA',
    clientID: ('; ' + document.cookie).split(`; _gid=`).pop().split(';')[0],
    lang: 'english',
    notifyAlert: document.querySelector('[data-element="notification"]'),
  },
  getPosition() {
    return !!localStorage !== false
      ? !!localStorage.getItem('position') !== false
        ? localStorage.getItem('position')
        : 'NA'
      : 'NA';
  },
  setPosition($position) {
    if (!!localStorage !== false) {
      localStorage.setItem('position', $position);
    }
  },
  isOnScreen(elem) {
    // if the element doesn't exist, abort
    if (!!elem == false || elem.length == 0) {
      return;
    }
    var $window = jQuery(window);
    var viewport_top = $window.scrollTop();
    var viewport_height = $window.height();
    var viewport_bottom = viewport_top + viewport_height;
    var $elem = jQuery(elem);
    var top = $elem.offset().top;
    var height = $elem.height();
    var bottom = top + height;

    return (
      (top >= viewport_top && top < viewport_bottom) ||
      (bottom > viewport_top && bottom <= viewport_bottom) ||
      (height > viewport_height &&
        top <= viewport_top &&
        bottom >= viewport_bottom)
    );
  },
  logo() {
    jQuery(document).on('click', '.logo', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      dataLayer.push({
        event: 'logo_click',
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      window.location.href = jQuery(this).attr('href');
    });
  },

  languageList() {
    jQuery(document).on('click', '[data-element="language"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $text = jQuery(this).text().toLowerCase();
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';

      dataLayer.push({
        event: 'select_language',
        language_name: `${$text}`,
      });

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  navMenuItem() {
    jQuery(document).on('click', 'li.primary-menu-item a', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $text = jQuery(this).text().toLowerCase();
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';

      dataLayer.push({
        event: 'top_navigation_click',
        navigation_click: `${$text}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
    jQuery(document).on('click', 'li.secondary-menu-item a', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $text = jQuery(this).text().toLowerCase();
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';

      dataLayer.push({
        event: 'sub_navigation_click',
        navigation_click: `${$text}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
    jQuery(document).on('click', '[data-element="footerlink"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $text = jQuery(this).text().toLowerCase();
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';

      dataLayer.push({
        event: 'bottom_navigation_click',
        navigation_click: `${$text}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
    jQuery(document).on('click', '[data-element="footernav"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $text = jQuery(this).data('title').toLowerCase();
      var $href = jQuery(this).attr('href');
      dataLayer.push({
        event: 'bottom_navigation_click',
        navigation_click: `${$text}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      window.location.href = $href;
    });
    jQuery(document).on('click', '[data-element="footersocial"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $text = jQuery(this).data('title').toLowerCase();
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';

      dataLayer.push({
        event: 'bottom_navigation_click',
        navigation_click: `${$text}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  searchInitiate() {
    jQuery(document).on('click', '[data-element="search"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      dataLayer.push({
        event: 'search_initiate',
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
    });
  },

  searchBox() {
    jQuery(document).on('click', '[data-element="searchform"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      dataLayer.push({
        event: 'search_complete',
        previous_page_path: `${dataLayersWP.el.referrer}`,
        search_text: `${jQuery('#vsbl__search-input').val()}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      jQuery('#vspl__searchform').submit();
    });
  },

  hamburgerMenu() {
    if (jQuery('[data-hamburgur="menu"].active').length == 0) {
      dataLayer.push({
        event: 'hamburger_menu_click',
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
    } else {
      this.hamburgerMenuClose();
    }
  },

  hamburgerMenuClose() {
    dataLayer.push({
      event: 'hamburger_close_click',
      previous_page_path: `${dataLayersWP.el.referrer}`,
      language_name: `${dataLayersWP.el.lang}`,
    });
  },

  articleClick() {
    jQuery(document).on(
      'click',
      '[data-element="article"] [data-element="href"]',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $articleData = jQuery(this)
          .parents('[data-element="article"]')
          .data('article');
        var $href = jQuery(this).attr('href');
        dataLayer.push({
          event: 'article_click',
          article_name: `${$articleData.article_name}`,
          author_name: `${$articleData.author_name}`,
          article_id: `${$articleData.article_id}`,
          article_topic: `${$articleData.article_topic}`,
          article_subtopic:`${$articleData.article_subtopic}`,
          article_section: `${$articleData.article_section}`,
          article_location: `${$articleData.article_location}`,
          publish_date: `${$articleData.publish_date}`,
          position: `${$articleData.position}`,
          previous_page_path: `${dataLayersWP.el.referrer}`,
          language_name: `${dataLayersWP.el.lang}`,
        });
        dataLayersWP.setPosition($articleData.position);
        window.location.href = $href;
        return false;
      }
    );

    jQuery(document).on(
      'click',
      '[data-element="article"] .nav-links a',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $articleData = jQuery(this)
          .parents('[data-element="article"]')
          .data('article');
        var $href = jQuery(this).attr('href');

        var $article_location = jQuery(this).attr('rel');
        dataLayer.push({
          event: 'article_click',
          article_name: `${$articleData.article_name}`,
          author_name: `${$articleData.author_name}`,
          article_id: `${$articleData.article_id}`,
          article_topic: `${$articleData.article_topic}`,
          article_subtopic:`${$articleData.article_subtopic}`,
          article_section: `post-navigation`,
          article_location: `${$article_location}`,
          publish_date: `${$articleData.publish_date}`,
          position: `${$articleData.position}`,
          previous_page_path: `${dataLayersWP.el.referrer}`,
          language_name: `${dataLayersWP.el.lang}`,
        });
        dataLayersWP.setPosition($articleData.position);
        window.location.href = $href;
        return false;
      }
    );
  },

  articleShareClick() {
    jQuery(document).on('click', '[data-icon="social"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      dataLayer.push({
        event: 'article_share_click',
        social_category: `${$tracker.social_category}`,
        article_name: `${$tracker.article_name}`,
        article_id: `${$tracker.article_id}`,
        author_name: `${$tracker.author_name}`,
        article_topic: `${$tracker.article_topic}`,
        article_subtopic:`${$tracker.article_subtopic}`,
        publish_date: `${$tracker.publish_date}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        position: `${$tracker.position}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);

      if (jQuery(this).hasClass('clipboard')) {
        //Clipboard
      } else if (!!$href !== false) {
        if ($target == '_self') {
          window.location.href = $href;
        } else {
          window.open($href, $target);
        }
      }
    });
  },

  topicCardClick() {
    jQuery(document).on('click', '[data-element="topic"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $position = jQuery(this).data('position');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      var $title = jQuery(this)
        .find('[data-term="title"]')
        .text()
        .toLowerCase();

      dataLayer.push({
        event: 'topic_card_click',
        topic_name: `${$title}`,
        position: `${$position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  termClick() {
    jQuery(document).on(
      'click',
      '[data-element="article"] [data-element="term"]',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $articleData = jQuery(this)
          .parents('[data-element="article"]')
          .data('article');
        var $href = jQuery(this).attr('href');
        dataLayer.push({
          event: 'article_topic_click',
          topic_name: jQuery(this).text().toLowerCase(),
          article_name: `${$articleData.article_name}`,
          author_name: `${$articleData.author_name}`,
          article_id: `${$articleData.article_id}`,
          article_topic: `${$articleData.article_topic}`,
          article_subtopic:`${$articleData.article_subtopic}`,
          publish_date: `${$articleData.publish_date}`,
          position: `${$articleData.position}`,
          previous_page_path: `${dataLayersWP.el.referrer}`,
          language_name: `${dataLayersWP.el.lang}`,
        });
        dataLayersWP.setPosition($articleData.position);
        window.location.href = $href;
        return false;
      }
    );
  },

  seeAllCta($topic) {
    dataLayer.push({
      event: 'see_all_click',
      topic_name: `${$topic.toLowerCase()}`,
      previous_page_path: `${dataLayersWP.el.referrer}`,
      language_name: `${dataLayersWP.el.lang}`,
    });
  },

  contributeCta() {
    jQuery(document).on('click', '[data-element="contribute"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $position = jQuery(this).data('position');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      var $title = jQuery(this).data('contribute');
      dataLayer.push({
        event: 'donation_amount_click',
        cta_text: `${$title}`,
        position: `${$position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  postReactions($icon) {
    var $data = jQuery('[data-element="article"]').data('article');
    dataLayer.push({
      event: 'feedback_icon_click',
      icon_name: `${$icon.name}`,
      article_name: `${$data.article_name}`,
      author_name: `${$data.author_name}`,
      article_id: `${$data.article_id}`,
      article_topic: `${$data.article_topic}`,
      article_subtopic:`${$data.article_subtopic}`,
      publish_date: `${$data.publish_date}`,
      previous_page_path: `${dataLayersWP.el.referrer}`,
      position: `${$icon.position}`,
      language_name: `${dataLayersWP.el.lang}`,
    });
  },

  newsletter() {
    dataLayer.push({
      event: 'subscription_click',
      previous_page_path: `${dataLayersWP.el.referrer}`,
      language_name: `${dataLayersWP.el.lang}`,
    });
  },

  heroCarousel() {
    jQuery(document).on('click', '[data-carousel="homepage"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      dataLayer.push({
        event: 'banner_click',
        article_name: `${$tracker.article_name}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);
      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  webStory() {
    jQuery(document).on('click', '[data-element="webstory"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      dataLayer.push({
        event: 'webstory_click',
        story_name: `${$tracker.story_name}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);
      window.location.href = $href;
    });
  },

  faqClick() {
    jQuery(document).on('click', '[data-element="faqlink"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      dataLayer.push({
        event: 'faq_click',
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      window.location.href = $href;
    });
  },

  aboutCta() {
    jQuery(document).on('click', '[data-cta="about"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $ctaTitle = jQuery(this).text();
      dataLayer.push({
        event: 'about_us_clicks',
        cta_text: `${$ctaTitle.toLowerCase()}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      window.location.href = $href;
    });
  },

  impactStory() {
    jQuery(document).on('click', '[data-element="impactstory"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      dataLayer.push({
        event: 'impact_article_view_click',
        article_name: `${$tracker.impact_name}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);
      window.location.href = $href;
    });
  },

  advertiseBannerCta() {
    jQuery(document).on('click', '[data-cta="gotoadvertise"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      dataLayer.push({
        event: 'advertise_with_us_click',
        cta_text: 'advertise with us',
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      jQuery('html, body').animate(
        {
          scrollTop: jQuery('#vspl__advertise-form').offset().top,
        },
        500
      );
    });
  },

  contactForm() {
    dataLayer.push({
      event: 'get_in_touch_submit',
      previous_page_path: `${dataLayersWP.el.referrer}`,
      language_name: `${dataLayersWP.el.lang}`,
    });
  },

  brandCampaign() {
    jQuery(document).on('click', '[data-element="casestudy"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      var $brandName = $tracker.brand_name;
      dataLayer.push({
        event: 'brand_campaign_click',
        campaign_name: `${$tracker.case_title}`,
        brand_name: `${$brandName.toLowerCase()}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);
      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  betterMarket() {
    jQuery(document).on(
      'click',
      '[data-element="BetterMarketBuyNow"]',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $href = jQuery(this).attr('href');
        var $tracker = jQuery(this).data('tracker');
        var $targetAttr = jQuery(this).attr('target');
        var $target = !!$targetAttr !== false ? $targetAttr : '_self';

        dataLayer.push({
          event: 'buy_now_click',
          product_name: `${$tracker.product_name}`,
          price: `${$tracker.price}`,
          previous_page_path: `${dataLayersWP.el.referrer}`,
          language_name: `${dataLayersWP.el.lang}`,
        });

        if ($target == '_self') {
          window.location.href = $href;
        } else {
          window.open($href, $target);
        }
      }
    );
  },

  tbiImpact() {
    jQuery(document).on('click', '[data-element="tbiimpact"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      dataLayer.push({
        event: 'tbi_impact_thumbnail_click',
        thumbnail_title: `${$tracker.thumbnail_title}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  videoStory($tracker) {
    dataLayer.push({
      event: 'video_stories_thumbnail_click',
      thumbnail_title: `${$tracker.thumbnail_title}`,
      position: `${$tracker.position}`,
      previous_page_path: `${dataLayersWP.el.referrer}`,
      language_name: `${dataLayersWP.el.lang}`,
    });
    dataLayersWP.setPosition($tracker.position);
  },

  smallBuzSpotlight() {
    jQuery(document).on('click', '[data-element="sbs"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      dataLayer.push({
        event: 'small_business_spotlight_click',
        thumbnail_title: `${$tracker.thumbnail_title}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  deepDive() {
    jQuery(document).on('click', '[data-element="deepdive"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      dataLayer.push({
        event: 'deep_dive_thumbnail_click',
        thumbnail_title: `${$tracker.thumbnail_title}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  awards() {
    jQuery(document).on('click', '[data-element="awards"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      dataLayer.push({
        event: 'tbi_events_and_awards_click',
        thumbnail_title: `${$tracker.thumbnail_title}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  authorBio() {
    jQuery(document).on('click', '[data-element="author"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery('[data-element="article"]').data('article');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';

      dataLayer.push({
        event: 'article_author_click',
        article_name: `${$tracker.article_name}`,
        author_name: `${$tracker.author_name}`,
        article_id: `${$tracker.article_id}`,
        article_topic: `${$tracker.article_topic}`,
        article_subtopic:`${$tracker.article_subtopic}`,
        publish_date: `${$tracker.publish_date}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  miscellaneousLink() {
    jQuery(document).on('click', '#vspl__article_content a', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery('[data-element="article"]').data('article');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      var $linkText = jQuery(this).text().toLowerCase();

      dataLayer.push({
        event: 'miscellaneous_link_clicks',
        clicked_text: `${$linkText}`,
        clicked_hyperlink: `${$href}`,
        article_name: `${$tracker.article_name}`,
        author_name: `${$tracker.author_name}`,
        article_id: `${$tracker.article_id}`,
        article_topic: `${$tracker.article_topic}`,
        article_subtopic:`${$tracker.article_subtopic}`,
        publish_date: `${$tracker.publish_date}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  advertiseSubmit() {
    dataLayer.push({
      event: 'advertise_submit',
      previous_page_path: `${dataLayersWP.el.referrer}`,
      language_name: `${dataLayersWP.el.lang}`,
    });
  },

  bannerImpression() {
    var $bannerItem = jQuery(
      '.vspl__hero--carousel--item.slick-slide.slick-current.slick-active [data-carousel="homepage"]'
    );
    //if (!!$bannerItem.hasClass('tracked') == false) {
      var slideData = $bannerItem.data('tracker');
      dataLayer.push({
        event: 'banner_impression',
        article_name: `${slideData.article_name}`,
        article_id: `${slideData.article_id}`,
        position: `${slideData.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      $bannerItem.addClass('tracked');
    //}
  },

  bannerImpressionChecker() {
    jQuery(window).scroll(function () {
      clearTimeout(jQuery.data(this, 'scrollCheck'));
      jQuery.data(
        this,
        'scrollCheck',
        setTimeout(function () {
          var heroCarouselBanner = document.querySelector(
            '.vspl__hero--carousel--item.slick-slide.slick-current.slick-active'
          );
          if (dataLayersWP.isOnScreen(heroCarouselBanner) == true) {
            dataLayersWP.bannerImpression();
          }
        }, 1000)
      );
    });
  },

  tbaCourseTracking() {
    jQuery(document).on('click', '[data-element="tba"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      dataLayer.push({
        event: 'the_better_academy',
        thumbnail_title: `${$tracker.thumbnail_title}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        course_type: `${$tracker.course_type}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);

      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },

  notificationImpression() {
    var $notificationItem = jQuery('[data-element="notification"]');
    if (!!$notificationItem.hasClass('tracked') == false) {
      var slideData = jQuery('[data-element="notificationlink"]').data(
        'tracker'
      );
      dataLayer.push({
        event: 'notification_impression',
        article_name: `${slideData.article_name}`,
        article_location: `${slideData.article_location}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      $notificationItem.addClass('tracked');
    }
  },

  notificationLink() {
    jQuery(document).on(
      'click',
      '[data-element="notificationlink"]',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopImmediatePropagation();

        var $href = jQuery(this).attr('href');
        var $tracker = jQuery(this).data('tracker');
        var $targetAttr = jQuery(this).attr('target');
        var $target = !!$targetAttr !== false ? $targetAttr : '_self';

        dataLayer.push({
          event: 'notification_click',
          article_name: `${$tracker.article_name}`,
          article_location: `${$tracker.article_location}`,
          previous_page_path: `${dataLayersWP.el.referrer}`,
          language_name: `${dataLayersWP.el.lang}`,
        });
        if ($target == '_self') {
          window.location.href = $href;
        } else {
          window.open($href, $target);
        }
      }
    );
  },

  notificationaImpressionChecker() {
    jQuery(window).scroll(function () {
      var notification = document.querySelector(
        '[data-element="notification"]'
      );
      if (dataLayersWP.isOnScreen(notification) == true) {
        dataLayersWP.notificationImpression();
      }
    });
  },
  stickyTrigger() {
    jQuery(document).on('click', '[data-nav="sub"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $text = jQuery(this).text().toLowerCase();
      dataLayer.push({
        event: 'top_navigation_click',
        navigation_click: `${$text}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      window.location.href = $href;
    });
    jQuery(document).on('click', '[data-social="sticky"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $text = jQuery(this).data('title').toLowerCase();
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      dataLayer.push({
        event: 'sub_navigation_click',
        navigation_click: `${$text}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      if (jQuery(this).hasClass('clipboard')) {
        //Clipboard
      } else {
        if ($target == '_self') {
          window.location.href = $href;
        } else {
          window.open($href, $target);
        }
      }
    });
  },

  ytVideoElement() {
    jQuery(document).on('click', '[data-element="ytvideo"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var $href = jQuery(this).attr('href');
      var $tracker = jQuery(this).data('tracker');
      var $targetAttr = jQuery(this).attr('target');
      var $target = !!$targetAttr !== false ? $targetAttr : '_self';
      dataLayer.push({
        event: 'video_stories_thumbnail_click',
        thumbnail_title: `${$tracker.thumbnail_title}`,
        video_type: `${$tracker.type}`,
        video_location: `${$tracker.location}`,
        position: `${$tracker.position}`,
        previous_page_path: `${dataLayersWP.el.referrer}`,
        language_name: `${dataLayersWP.el.lang}`,
      });
      dataLayersWP.setPosition($tracker.position);
      if ($target == '_self') {
        window.location.href = $href;
      } else {
        window.open($href, $target);
      }
    });
  },
  adbannerimpression() {
    var $adBannerItems = jQuery('[data-carousel="adbanner"]');
    if ($adBannerItems.length === 0) {
      return; // Exit the function if no ad banners exist
    }
    $adBannerItems.each(function () {
      var $adBannerItem = jQuery(this);
      if (!$adBannerItem.hasClass('tracked')) {
        var observer = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var slideData = JSON.parse($adBannerItem.attr('data-tracker'));
              dataLayer.push({
                event: 'banner_impression',
                article_name: `${slideData.article_name}`,
                article_id: `${slideData.article_id}`,
                position: `${slideData.position}`,
                previous_page_path: `${dataLayersWP.el.referrer}`,
                language_name: `${dataLayersWP.el.lang}`,
              });
              $adBannerItem.addClass('tracked');
              observer.disconnect();
            }
          });
        }, {
          threshold: 0.5 // 50% of the banner needs to be visible to trigger the impression
        });
        observer.observe($adBannerItem[0]);
      }
    });
  },
  init() {
    this.logo();
    this.languageList();
    this.navMenuItem();
    this.searchInitiate();
    this.searchBox();
    this.articleClick();
    this.articleShareClick();
    this.topicCardClick();
    this.termClick();
    this.contributeCta();
    this.heroCarousel();
    this.webStory();
    this.faqClick();
    this.aboutCta();
    this.impactStory();
    this.advertiseBannerCta();
    this.brandCampaign();
    this.betterMarket();
    this.tbiImpact();
    this.smallBuzSpotlight();
    this.deepDive();
    this.awards();
    this.authorBio();
    this.miscellaneousLink();
    this.tbaCourseTracking();
    this.ytVideoElement();
    this.adbannerimpression();
    if (jQuery('#herocarousel').length > 0) {
      this.bannerImpressionChecker();
    }
    var alertItem = dataLayersWP.el.notifyAlert;
    if (!!alertItem !== false && alertItem.length > 0) {
      this.notificationaImpressionChecker();
    }

    this.notificationLink();
    this.stickyTrigger();
  },
};

jQuery(document).ready(function () {
  dataLayersWP.init();
});

jQuery(window).load(function () {
  if (jQuery('#herocarousel').length > 0) {
    setTimeout(() => {
      var heroCarouselBanner = document.querySelector(
        '.vspl__hero--carousel--item.slick-slide.slick-current.slick-active'
      );
      if (dataLayersWP.isOnScreen(heroCarouselBanner) == true) {
        dataLayersWP.bannerImpression();
      }
    }, 1000);
  }
});
